import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-5 d-flex justify-content-center align-items-center"
}

import { onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableFooter',
  props: {
    criteria: {},
    total: { default: 5 },
    itemsPerPage: { default: 10 },
    itemsPerPageDropdownEnabled: { type: Boolean, default: true }
  },
  emits: [
  "update:itemsPerPage",
  "page-change",
  "update-page",
],
  setup(__props: any, { emit: emits }) {

const props = __props;




const page = ref(1);
const inputItemsPerPage = ref(10);

watch(
  () => props.criteria?.page,
  (newPage) => {
    if (typeof newPage !== "number") return;
    page.value = newPage;
  }
);

onMounted(() => {
  inputItemsPerPage.value = props.criteria
    ? (props.criteria.size as number)
    : props.itemsPerPage;
});

const pageChange = (newPage: number) => {
  if (page.value === newPage) return;
  page.value = newPage;
  emits("page-change", page.value);
};

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_ctx.criteria)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_pagination, {
          "hide-on-single-page": true,
          "page-size": _ctx.criteria?.size,
          layout: "prev, pager, next",
          "current-page": page.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (pageChange($event))),
          "page-count": 
        _ctx.criteria?.total ? Math.ceil(_ctx.criteria?.total / _ctx.criteria?.size) : 1
      
        }, null, 8, ["page-size", "current-page", "page-count"])
      ]))
    : _createCommentVNode("", true)
}
}

})